import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { UpdateFacade } from '@app/store/update';
import { IconComponent } from '@shared/components';

@Component({
    selector: 'app-update-banner',
    templateUrl: './update-banner.component.html',
    styleUrls: ['./update-banner.component.css'],

    imports: [IconComponent, TranslatePipe],
})
export class UpdateBannerComponent {
    private readonly updateFacade = inject(UpdateFacade);

    protected readonly pending = this.updateFacade.pending;

    protected apply(): void {
        this.updateFacade.apply();
    }
}
